import { useAuth } from '../context/AuthContext.js';

/**
 * 085 (gap-list F6): the id of whoever the app is currently acting as.
 *
 * It is the administrator's own id normally, and the **target's** while acting as someone else —
 * `enterImpersonation` reads `/users/me` with the impersonation token before it sets state
 * (`AuthContext.tsx:127-140`), so `user` is already the target by the time anything renders.
 *
 * 🔴 The **id**, deliberately, and not one of the three things it could plausibly have been:
 *
 *  - the `user` **object** — 051's `refreshUser()` replaces it after a profile or avatar edit with
 *    the same `_id`. Keying a read on the object would re-issue it on every profile save (FR-012).
 *  - the **access token** — a credential rather than an identity. `api.ts` already resolves the
 *    right one per request; what this value decides is *when to ask again*, not what to send.
 *  - `isImpersonating` — a boolean, which cannot distinguish two consecutive targets.
 *
 * Named rather than inlined because two surfaces consume it and the choice above must have one
 * answer, not two (research R7).
 */
export function useActingIdentity(): string | null {
  return useAuth().user?._id ?? null;
}
